import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { InfoControl } from '../../RIValidation/components/InfoControl';
import { ContratosPaciente } from '../../RIValidation/components/ContratosPaciente';
import { DireccionContent } from "../../RIValidation/components/DireccionContent";
import { Profesionales } from "../../RIValidation/components/Profesionales";
import { CambioProgramaInput } from "./CambioProgramaInput";
import { AptoInput } from "../../RIValidation/components/AptoInput";
import { useGetActions } from "../hooks/useGetActions";

export const RIAsignacionContent = ({ setChildrenAction }) => {
    const location = useLocation();
    const stateData = location.state;
    const { notificationData, delegaciones, tipoNotificacion, idDelegacion, idTipoModulo } = stateData;
    const [notification, setNotification] = useState(notificationData || {});
    const isReasignacion = !!notificationData?.profesionalASignado;
    const [contratosIds, setContratosIds] = useState([]);
    const [apto, setApto] = useState(false);

    const handleChange = (name, value) => {
        setNotification(prevDatos => ({
            ...prevDatos,
            [name]: value
        }));
    }

    const {
        handleClickAsignar,
        handleClickValidar,
        handleClickCambiarPrograma,
        loading: buttonActionLoading
    } = useGetActions({ handleChange, isReasignacion, notification });

    useEffect(() => {
        if (!notification) return setChildrenAction(null);

        setChildrenAction(() => (
            <>
                {!!notificationData?.estadoCoordinador && notificationData?.estadoCoordinador !== 'Rechazado' && <div className='top-buttons'>
                    {!notificationData?.profesionalASignado && <div className='margin-right'>
                        <CambioProgramaInput
                            idEvaluacion={notification?.idEvaluacion}
                            loadingOthersButtons={buttonActionLoading}
                            handleClickAceptar={() => handleClickCambiarPrograma()}
                        />
                    </div>
                    }
                    <div className='margin-right'>
                        <AptoInput
                            idEvaluacion={notification?.idEvaluacion}
                            handleClickAceptar={(rechazo) => handleClickValidar(rechazo)}
                            loadingValidar={buttonActionLoading}
                            isReject={true}
                            apto={apto}
                        />
                    </div>
                    <div className='margin-right'>
                        <Profesionales
                            idDelegacion={idDelegacion}
                            idTipoModulo={idTipoModulo}
                            handleRowClick={(row) => handleClickAsignar(row)}
                            loading={buttonActionLoading}
                            name={!!notification?.profesionalASignado ? "Reasignar" : null}
                            notification={notification}
                        />
                    </div>
                </div>}
            </>
        ))
    }, [notification, contratosIds, buttonActionLoading, apto]);

    return <>
        <InfoControl
            notification={notification}
            tipoNotificacion={tipoNotificacion}
        />
        <DireccionContent
            notification={notification}
            setApto={setApto}
        />
        <ContratosPaciente
            idPaciente={notification?.hC}
            setContratosIds={setContratosIds}
        />
    </>
}